import React from 'react';
import BaseClassComponent from '../../shared/base.jsx';

class TextComponent extends BaseClassComponent {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onCustomValueChanged(this.props.customFieldDefinition, e.currentTarget.value);
    }

    render() {
        let txtValue = '';
        let isReadOnly = false;
        if (this.props.customFieldValues && this.props.customFieldValues.Values) {
            txtValue = this.props.customFieldValues.Values[0];
        }
        let css = 'input-text ';
        if (this.props.customFieldDefinition.IsMandatory) {
            css += 'required';
        }

        if (this.props.customFieldDefinition.Code.includes('-BCAAMemberID-')) {
            isReadOnly = true;
        }
        if (this.props.customFieldDefinition.Code.includes('-MemberJoinDate-')) {
            isReadOnly = true;
            let dateJoin = new Date(txtValue);
            let formattedDate = dateJoin.toLocaleDateString('en-GB');
            txtValue = formattedDate;
        }
        return (
            <div className='input-container'>
                {' '}
                <span className='additional-one'>{this.props.customFieldDefinition.Name}</span>
                <input
                    type='text'
                    readOnly={isReadOnly}
                    className={css}
                    name='additional-one'
                    placeholder=''
                    onChange={this.onChange}
                    defaultValue={txtValue === 'Invalid Date' ? '' : txtValue}
                />
            </div>
        );
    }
}

export default TextComponent;
